export default __webpack_public_path__ + "static/avatar-kayi-common-2-detail-fe9aeec571fb5f6212c48f6fe9deca11.png";